import {
    Button,
    Checkbox,
    Dialog,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
} from '@material-ui/core';

import React, { useState } from 'react';
import { connect } from 'react-redux';
import en from '../../../../lang/en-us';
import TextInput from '../../../../lib/TextField';
import { RootStateType } from '../../../../redux-store/reducers';
import { sendPhoneOTP } from '../../../../redux-store/actions/nct';
import {
    FORM_15GH,
    getDateString,
    isNumber,
    minDateForCalender,
    OTP_ACTIONS,
    _minDateForCalender,
} from '../../../../utils/constants';
import { useEffect } from 'react';
import { Form15Response } from '../../../../redux-store/types/nct';
import { financialYear } from './utils';
import moment from 'moment';
import DatePickerInput from '../../../../lib/DatePicker';
import { CustomRadio } from '../../../../lib/CustomRadio';
import { ActionHeader, FaqLink } from '..';

const { dashboard, common } = en;

const getMaxYear = () => {
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();

    return currentMonth > 4
        ? new Date(`03-31-${currentYear - 59}`)
        : new Date(`03-31-${currentYear - 1 - 59}`);
};

const amountValidation: any = {
    '15G': 250000,
    '15H': 1000000,
};

const getLastFiveFinancialYear = () => {
    const currentYear = new Date().getFullYear();
    let fiveFinancialYears: Array<string> = [];
    for (let i = 0; i < 5; i++) {
        fiveFinancialYears.push(financialYear(currentYear - i - 1));
    }
    return fiveFinancialYears;
};

function UpdateForm15Income(props: any) {
    const { type, targetFunds } = props.location.state || {};
    const [open, setOpen] = useState(false);
    const [DividendIncome, setDividentIncome] = useState<string>('');
    const [cummulativeIncome, setCummulativeIncome] = useState<string>('');
    const [totalIncome, setTotalIncome] = useState<string>('');
    const [isAssessedUnderTaxAct, setTaxAct] = useState<string>('');
    const [lastAssessmentYear, setAssesmentYear] = useState<string>('');
    const [errors, setErrors] = useState<any>({
        dividendIncome: false,
        cummulative: false,
        totalIncome: false,
    });
    const [valueErrors, setValueErrors] = useState<any>({
        dividendIncome: false,
        totalIncome: false,
        cummulative: false,
    });
    const [dobError, setDobError] = useState<string>('');
    const [checked, setChecked] = useState<boolean>(false);
    const [dob, setDob] = useState<any>('');

    useEffect(() => {
        if (!type) {
            props.history.push('/');
        }
    });

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setChecked(false);
    };

    const _checkDividendIncome = async () => {
        if (DividendIncome && Number(DividendIncome) === 0) {
            setValueErrors((state: any) => ({
                ...state,
                dividendIncome: true,
            }));
            return;
        }
        if (amountValidation[type] < Number(DividendIncome)) {
            await setErrors((state: any) => ({
                ...state,
                dividendIncome: true,
            }));
        }
        if (totalIncome) {
            _checkForTotalIncome();
        }
        if (cummulativeIncome) {
            _checkCummulativeIncome();
        }
    };

    const _checkForTotalIncome = () => {
        if (totalIncome && Number(totalIncome) === 0) {
            setValueErrors((state: any) => ({
                ...state,
                totalIncome: true,
            }));
            return;
        }
        if (totalIncome && Number(totalIncome) < Number(DividendIncome)) {
            setErrors((state: any) => ({
                ...state,
                totalIncome: true,
            }));
        } else {
            setErrors((state: any) => ({
                ...state,
                totalIncome: false,
            }));
        }
    };

    const _checkCummulativeIncome = () => {
        if (
            cummulativeIncome &&
            (Number(cummulativeIncome) === 0 || Number(cummulativeIncome) < Number(DividendIncome))
        ) {
            setValueErrors((state: any) => ({
                ...state,
                cummulative: true,
            }));
        } else {
            setValueErrors((state: any) => ({
                ...state,
                cummulative: false,
            }));
        }
        if (cummulativeIncome && amountValidation[type] < Number(cummulativeIncome)) {
            setErrors((state: any) => ({
                ...state,
                cummulative: true,
            }));
        } else {
            setErrors((state: any) => ({
                ...state,
                cummulative: false,
            }));
        }
    };

    const handleSubmit = async () => {
        const { mobile, pan, pekrn } = props;
        try {
            let res = await props.sendPhoneOTP({
                mobile,
                pan,
                pekrn,
                action: OTP_ACTIONS.FORM_15,
            });

            const data = targetFunds.map((_ele: Form15Response) => ({
                amc: _ele.amc,
                formType: type,
                dob: getDateString(dob),
                currentYear: financialYear(new Date().getFullYear()),
                estimatedDividendIncome: DividendIncome,
                totalIncome: totalIncome,
                cummulativeIncome: cummulativeIncome,
                declaration: isAssessedUnderTaxAct,
                lastAssessmentYear,
            }));
            props.history.replace('update-form15-otp', {
                data,
                ...(res || {}).body,
                mobile,
            });
        } catch (err: any) {
            alert(err.message);
        }
    };

    const _checkForAge = () => {
        const currentMonth = new Date().getMonth();
        const currentYear = new Date().getFullYear();
        let fyStartYear = currentMonth > 4 ? `${currentYear}` : `${currentYear - 1}`;
        let fromDate = `04-01-${fyStartYear}`;
        const timeDifference = getMaxYear();
        var differenceInSeconds = (new Date(fromDate).getTime() - timeDifference.getTime()) / 1000;
        var seconds = (new Date(fromDate).getTime() - new Date(dob).getTime()) / 1000;
        if (differenceInSeconds - seconds > 86400) {
            setDobError(`Age should be greater than 59 years as on April 1st, ${fyStartYear}`);
        }
        if (new Date(dob) < new Date(minDateForCalender())) {
            setDobError(common.errors.dob.ageLessThanHundred);
        }
    };
    return (
        <div className="curved-bg">
            <ActionHeader
                header={
                    type === '15H'
                        ? dashboard.UpdateForm15.UpdateForm15HHeading
                        : dashboard.UpdateForm15.UpdateForm15GHeading
                }
            />
            <div className="curved-bg-content">
                <div className="curved-bg-content-inner form15-income-details">
                    <h4>
                        {dashboard.UpdateForm15.Income.heading}
                        {financialYear(new Date().getFullYear())}
                    </h4>
                    <div className="fields">
                        {type === '15H' && (
                            <>
                                <DatePickerInput
                                    id={'dob'}
                                    label={dashboard.UpdateForm15.Income.dob}
                                    value={dob}
                                    onChange={(date) => {
                                        setDob(date);
                                    }}
                                    minDate={_minDateForCalender()}
                                    maxDate={moment(getMaxYear()).format('YYYY-MM-DD')}
                                    error={!!dobError}
                                    helperText={dobError}
                                />
                            </>
                        )}
                        <div className="form15-income-field">
                            <TextInput
                                label={dashboard.UpdateForm15.Income.dividendIncome}
                                variant="outlined"
                                name={'amount'}
                                value={DividendIncome}
                                onBlur={_checkDividendIncome}
                                onFocus={() => {
                                    setErrors({
                                        ...errors,
                                        dividendIncome: false,
                                    });
                                    setValueErrors({
                                        ...valueErrors,
                                        dividendIncome: false,
                                    });
                                }}
                                onChange={({ target: { value } }) =>
                                    isNumber(value) ? setDividentIncome(value) : null
                                }
                            />
                            <p
                                style={{
                                    color:
                                        errors.dividendIncome || valueErrors.dividendIncome
                                            ? 'red'
                                            : '',
                                    alignItems: 'flex-start',
                                }}
                            >
                                {!valueErrors.dividendIncome ? (
                                    <>
                                        <img
                                            src={
                                                errors.dividendIncome
                                                    ? '/images/info-red.svg'
                                                    : '/images/info-grey.svg'
                                            }
                                            alt="icon"
                                            style={{
                                                paddingTop: 4,
                                            }}
                                        />
                                        {type === '15H'
                                            ? dashboard.UpdateForm15.Income
                                                .form15HdividendIncomeExceed
                                            : dashboard.UpdateForm15.Income
                                                .form15GdividendIncomeExceed}
                                    </>
                                ) : (
                                    'Estimated Income can not be 0'
                                )}
                            </p>
                        </div>
                        <div className="form15-income-field">
                            <TextInput
                                label={dashboard.UpdateForm15.Income.totalDividendIncome}
                                variant="outlined"
                                name={'amount'}
                                value={totalIncome}
                                onChange={({ target: { value } }) =>
                                    isNumber(value) ? setTotalIncome(value) : null
                                }
                                onBlur={_checkForTotalIncome}
                                onFocus={() => {
                                    setValueErrors({
                                        ...valueErrors,
                                        totalIncome: false,
                                    });
                                    setErrors({
                                        ...errors,
                                        totalIncome: false,
                                    });
                                }}
                            />
                            <p
                                style={{
                                    color:
                                        errors.totalIncome || valueErrors.totalIncome ? 'red' : '',
                                    alignItems: 'flex-start',
                                }}
                            >
                                {!valueErrors.totalIncome ? (
                                    <>
                                        {errors.totalIncome && (
                                            <>
                                                <img
                                                    src={
                                                        errors.totalIncome
                                                            ? '/images/info-red.svg'
                                                            : '/images/info-grey.svg'
                                                    }
                                                    alt="icon"
                                                    style={{
                                                        paddingTop: 5,
                                                    }}
                                                />
                                                {
                                                    dashboard.UpdateForm15.Income
                                                        .totalIncomeValidation
                                                }
                                            </>
                                        )}
                                    </>
                                ) : (
                                    'Total Income can not be 0'
                                )}
                            </p>
                        </div>
                    </div>
                    <div className="total-income-outer">
                        <div className="total-income">
                            <div>
                                <p>{dashboard.UpdateForm15.Income.cumulativeIncome}</p>
                                <TextInput
                                    variant="outlined"
                                    placeholder={dashboard.UpdateForm15.Income.enterAmount}
                                    value={cummulativeIncome}
                                    name={'amount'}
                                    onBlur={_checkCummulativeIncome}
                                    onFocus={() => {
                                        setValueErrors({
                                            ...valueErrors,
                                            cummulative: false,
                                        });
                                        setErrors({
                                            ...errors,
                                            cummulative: false,
                                        });
                                    }}
                                    onChange={({ target: { value } }) =>
                                        isNumber(value) ? setCummulativeIncome(value) : null
                                    }
                                />
                            </div>
                            <p
                                style={{
                                    color:
                                        errors.cummulative || valueErrors.cummulative ? 'red' : '',
                                    alignItems: 'flex-start',
                                }}
                            >
                                {valueErrors.cummulative
                                    ? 'Cumulative Dividend Amount should be more than or equal to Estimated Dividend'
                                    : type === '15H'
                                        ? dashboard.UpdateForm15.Income.form15HcumulativeIncomeExceed
                                        : dashboard.UpdateForm15.Income.form15GcumulativeIncomeExceed}
                            </p>
                        </div>
                    </div>
                    <div className="form15-assessed">
                        <CustomRadio
                            extraClass="form15-tax-accessed"
                            title={dashboard.UpdateForm15.TaxAccessed}
                            name="tax-accessed"
                            list={[
                                {
                                    label: dashboard.UpdateForm15.yes,
                                    value: 'Y',
                                },
                                {
                                    label: dashboard.UpdateForm15.no,
                                    value: 'N',
                                },
                            ]}
                            selectedValue={isAssessedUnderTaxAct}
                            handleRadioChange={(value: string) => {
                                setTaxAct(value);
                                setAssesmentYear('');
                            }}
                        />
                        {isAssessedUnderTaxAct === 'Y' && (
                            <FormControl variant="outlined">
                                <InputLabel id="select-financial-year">
                                    {dashboard.UpdateForm15.Income.lastAssesmentYear}
                                </InputLabel>
                                <Select
                                    labelId="update-form-15-financial-year-label"
                                    id="update-form-15-financial-year"
                                    name={dashboard.UpdateForm15.Income.lastAssesmentYear}
                                    value={lastAssessmentYear}
                                    onChange={({ target: { value } }: any) =>
                                        setAssesmentYear(value)
                                    }
                                >
                                    {getLastFiveFinancialYear().map((_ele: string) => (
                                        <MenuItem value={_ele}>{_ele}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                    </div>

                    {/* <p className="total-income-exceeds">
                        <img src="/images/error-red.svg" alt="icon" />
                            {dashboard.UpdateForm15.Income.incomeExceedLimit}
                        </p> */}
                    <div className="income-details">
                        <h4>{dashboard.UpdateForm15.Income.DetailsOfIncome}</h4>
                        <div className="income-details-info">
                            <p>{dashboard.UpdateForm15.Income.slNo}</p>
                            <span>1</span>
                        </div>
                        <div className="income-details-fields">
                            <div className="income-details-info">
                                <p>{dashboard.UpdateForm15.Income.idNo}</p>
                                <span>PAN</span>
                            </div>
                            <div className="income-details-info">
                                <p>{dashboard.UpdateForm15.Income.NatureOfIncome}</p>
                                <span>Dividend</span>
                            </div>
                            <div className="income-details-info">
                                <p>{dashboard.UpdateForm15.Income.SectionDeductible}</p>
                                <span>194K</span>
                            </div>
                            <div className="income-details-info">
                                <p>{dashboard.UpdateForm15.Income.AmountOfIncome}</p>
                                <span>{!DividendIncome ? '-----' : DividendIncome}</span>
                            </div>
                        </div>
                    </div>
                    <FaqLink section={FORM_15GH} history={props.history} />
                    <Button
                        className="customBtn"
                        disabled={
                            !DividendIncome ||
                            !cummulativeIncome ||
                            Object.values(errors).some((_ele) => _ele === true) ||
                            (type === '15H' && (!dob || !!dobError)) ||
                            Object.values(valueErrors).some((_ele) => _ele === true) ||
                            !isAssessedUnderTaxAct
                        }
                        onClick={handleClickOpen}
                    >
                        {dashboard.UpdateForm15.Income.buttonText}
                    </Button>
                </div>
            </div>
            <Dialog maxWidth={'md'} open={false} aria-labelledby="form15-not-applicable-modal">
                <div className="form15-not-applicable-modal">
                    <img src="/images/error-red.svg" alt="icon" />
                    <p>{dashboard.UpdateForm15.Income.incomeModalInfo}</p>
                    <ul>
                        <li>
                            1. ICICI Prudential Regular Savings Fund Direct-IDCW Monthly Payout -
                            20056123400
                        </li>
                    </ul>
                    <div className="buttons">
                        <Button className="customBtn">
                            {dashboard.UpdateForm15.Income.overwriteBtn}
                        </Button>
                        <Button className="customBtn">
                            {dashboard.UpdateForm15.Income.unselectBtn}
                        </Button>
                    </div>
                </div>
            </Dialog>
            <Dialog onClose={handleClose} aria-labelledby="form15-declaration" open={open}>
                <div className="form15-declaration-modal">
                    <h3>{dashboard.UpdateForm15.Income.declarationModal.heading}</h3>
                    <a onClick={handleClose}>
                        <img src="/images/close-black.svg" alt="close icon" />
                    </a>
                    <p>{dashboard.UpdateForm15.Income.declarationModal.para1}</p>
                    <p>{dashboard.UpdateForm15.Income.declarationModal.para2}</p>
                    <h4>Instructions</h4>
                    <p>{dashboard.UpdateForm15.Income.declarationModal.para3}</p>
                    <p>{dashboard.UpdateForm15.Income.declarationModal.para4}</p>
                    <p>{dashboard.UpdateForm15.Income.declarationModal.para5}</p>
                    <p>{dashboard.UpdateForm15.Income.declarationModal.para6}</p>
                    <p>{dashboard.UpdateForm15.Income.declarationModal.para7}</p>
                    <p>{dashboard.UpdateForm15.Income.declarationModal.para8}</p>
                    <div className="form15-income-declaration">
                        <FormControl>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="form15-declaration"
                                        value={checked}
                                        onChange={() => setChecked(!checked)}
                                    />
                                }
                                label={
                                    <>
                                        {dashboard.UpdateForm15.Income.declaration}{' '}
                                        {/* <a onClick={handleClickOpen}>
                                            {dashboard.UpdateForm15.Income.readMore}
                                        </a> */}
                                    </>
                                }
                            />
                        </FormControl>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <Button
                            // href="/portal/nct/update-form15-otp"
                            className="customBtn"
                            disabled={!checked}
                            onClick={handleSubmit}
                        >
                            {dashboard.UpdateForm15.Income.submit}
                        </Button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), { sendPhoneOTP })(
    UpdateForm15Income,
);
